<template>
  <div
    class="progress-ring"
    :style="{
      background: `radial-gradient(
        closest-side, ${
          isDarkMode ? 'var(--paper-background-color)' : 'white'
        } 75%, transparent 75% 100%
        ), conic-gradient(
          ${primaryColor} ${progressPercent}, ${secondaryColor} 0)
        `,
    }"
  >
    <div v-if="showNumeratorDenominator" class="progress-amount">
      <span class="numerator">{{ numerator }}</span
      ><span class="denominator">/{{ denominator }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    progressPercent: { type: String, default: '0%' },
    numerator: { type: Number, default: null },
    denominator: { type: Number, default: null },
    primaryColor: { type: String, default: '#71e200' },
    secondaryColor: { type: String, default: '#eaeaea' },
  },
  computed: {
    ...mapGetters(['isDarkMode']),
    showNumeratorDenominator() {
      if (this.numerator == null || this.denominator == null) {
        return false
      }
      return true
    },
  },
}
</script>
<style scoped>
.progress-ring {
  flex-shrink: 0;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-amount .numerator {
  font-size: 24px;
}

.progress-amount .denominator {
  font-size: 16px;
}
</style>
